import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
        path: "/:fadCode/:branchName",
        name: "Branch Accessibility",
        meta: {
            title: "Branch Accessibility"
        },
        component: () =>
            import ("../views/BranchAccessibility")
    },
    {
        path: "*",
        name: "Page not found",
        meta: {
            title: "Page not found"
        },
        component: () =>
            import ("../views/PageNotFound")
    }
];

const router = new VueRouter({
    routes
});

export default router;